module.exports = __webpack_public_path__ + "static/media/green-info.ebe32a16.svg";